/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');
import {routes} from './imports/routes.js';
import {store} from './imports/store.js';
import Vue from 'vue'; // es6 syntax
window.Vue = Vue;
import VueRouter from 'vue-router'

Vue.use(VueRouter)
const router = new VueRouter({
    routes,
    mode: 'history'
});

router.beforeEach((to, from, next) => {
    if (to.name !== 'Login' && localStorage.getItem('user-token') == null) next({ name: 'Login' })
    else next()
})


const app = new Vue({
    el: '#app',
    store,
    router
}).$mount('#app');
